module.exports = __webpack_public_path__ + "static/media/task7Planet1.97356b3c.png";